import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import Header from "components/Header/Header";
import {} from "@heroicons/react/24/outline";
import { Link, useLocation } from "react-router-dom";
import { PathName } from "routers/types";

let OPTIONS = {
  root: null,
  rootMargin: "0px",
  threshold: 1.0,
};
let OBSERVER: IntersectionObserver | null = null;
const PAGES_HIDE_HEADER_BORDER: PathName[] = ["/car-rental/:id"];

const SiteHeader = () => {
  const [isSticky, setIsSticky] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const show = window.scrollY > 60;
      if (show !== isSticky) {
        setIsSticky(show);
      }
    };

    document.addEventListener("scroll", handleScroll);
    return () => {
      document.removeEventListener("scroll", handleScroll);
    };
  }, [isSticky]);
  const anchorRef = React.useRef<HTMLDivElement>(null);

  const [isTopOfPage, setIsTopOfPage] = React.useState(window.pageYOffset < 5);
  const location = useLocation();

  const intersectionCallback = (entries: IntersectionObserverEntry[]) => {
    entries.forEach((entry) => {
      setIsTopOfPage(entry.isIntersecting);
    });
  };

  useEffect(() => {
    // disconnect the observer
    if (!PAGES_HIDE_HEADER_BORDER.includes(location.pathname as PathName)) {
      OBSERVER && OBSERVER.disconnect();
      OBSERVER = null;
      return;
    }
    if (!OBSERVER) {
      OBSERVER = new IntersectionObserver(intersectionCallback, OPTIONS);
      anchorRef.current && OBSERVER.observe(anchorRef.current);
    }
  }, [location.pathname]);

  const renderHeader = () => {
    let headerClassName = `shadow-sm dark:border-b text-white font-bold dark:border-neutral-700 ${
      isSticky ? "sticky nc-header-bg" : ""
    }`;
    if (PAGES_HIDE_HEADER_BORDER.includes(location.pathname as PathName)) {
      headerClassName = isTopOfPage
        ? ""
        : "shadow-sm dark:border-b dark:border-neutral-700 ";
    }

    return (
      <Header
        className={headerClassName}
        navType="MainNav1"
        isSticky={isSticky}
      />
    );
  };

  return (
    <>
      <Helmet>
        <title>長勝租車 Car Rental Service - 香港租車</title>
      </Helmet>
      {renderHeader()}
      <div className="relative z-40 ">
        <a
          href="https://wa.me/85265107107?text=你好長勝租車，我想查詢租車！"
          target="_blank"
          rel="noreferrer noopener"
        >
          <div className=" z-40 flex items-center  w-[60px] h-[60px] right-5 bottom-[4.25rem] md:bottom-5  fixed">
            {/* <svg
              xmlns="http://www.w3.org/2000/svg"
              x="0px"
              y="0px"
              width="100"
              height="100"
              viewBox="0,0,256,256"
              style={{ fill: "#40C057", position: "relative", zIndex: 100 }}
            >
              <g
                fill="#40c057"
                fill-rule="nonzero"
                stroke="none"
                stroke-width="1"
                stroke-linecap="butt"
                stroke-linejoin="miter"
                stroke-miterlimit="10"
                stroke-dasharray=""
                stroke-dashoffset="0"
                font-family="none"
                font-weight="none"
                font-size="none"
                text-anchor="none"
                style={{ mixBlendMode: "normal" }}
              >
                <g transform="scale(4,4)">
                  <path d="M32,8c-13.255,0 -24,10.297 -24,23c0,4.509 1.35922,8.71172 3.69922,12.26172l-1.69922,12.73828l15.40039,-2.88867c2.097,0.574 4.30961,0.88867 6.59961,0.88867c13.255,0 24,-10.297 24,-23c0,-12.703 -10.745,-23 -24,-23zM32,11.42969c5.802,-0.059 11.59145,2.50811 15.43945,6.91211c3.884,4.38 5.58761,10.60853 4.47461,16.39453c-1.065,5.818 -4.99102,10.93728 -10.16602,13.73828c-5.056,2.711 -11.26312,3.22741 -16.70312,1.31641l-9.78125,2.17383l-1.5293,0.33984l0.28906,-1.52148v-0.00195l1.34961,-8.2207c-0.862,-1.38 -1.59149,-2.82694 -2.14649,-4.33594c-0.612,-1.744 -1.01806,-3.55091 -1.16406,-5.37891c-0.072,-0.914 -0.08667,-1.82923 -0.01367,-2.74023c0.017,-0.916 0.17312,-1.81875 0.32813,-2.71875c0.392,-1.779 0.93931,-3.54158 1.82031,-5.14258c0.843,-1.612 1.8793,-3.13741 3.1543,-4.44141c0.596,-0.692 1.31724,-1.25809 1.99023,-1.87109c0.738,-0.533 1.44409,-1.11669 2.24609,-1.55469c3.104,-1.932 6.76611,-2.87527 10.41211,-2.94726zM31.99609,14c-3.193,0.024 -6.41302,0.79503 -9.16602,2.45703c-0.713,0.373 -1.33514,0.88284 -1.99414,1.33984c-0.595,0.535 -1.24753,1.01786 -1.76953,1.63086c-1.131,1.141 -2.04397,2.48153 -2.79297,3.89453c-1.49,2.845 -2.06323,6.12483 -1.74023,9.29883c0.362,3.169 1.76306,6.19475 3.91406,8.46875v0.00195l0.46484,0.57031l-0.18359,0.6543l-1.89648,6.73047l8.07617,-2.61914l0.00195,-0.00195l0.4375,-0.14062l0.46484,0.18359c4.618,1.819 10.00592,1.48812 14.41992,-0.79687c4.395,-2.311 7.77728,-6.59109 8.73828,-11.49609c1.001,-4.891 -0.35744,-10.20058 -3.64844,-14.01758c-3.264,-3.833 -8.24417,-6.1412 -13.32617,-6.1582zM24.39258,21.24805c0.566,0.002 2.16992,0 2.16992,0l2.16992,5.42383c-0.772,1.209 -1.56563,1.88397 -2.14062,2.54297c0.321,0.782 1.63636,2.73256 3.19336,4.10156c2.007,1.76 3.74628,2.58222 4.98828,2.82422c0.65,-0.484 2.28967,-2.44098 2.63867,-2.95898l5.42383,2.16992c0,1.085 -0.14003,1.65724 -0.58203,2.86523c-0.434,1.208 -2.52706,2.31203 -3.53906,2.45703c-0.902,0.136 -2.04178,0.18787 -3.30078,-0.20312c-0.757,-0.238 -1.73437,-0.55384 -2.98437,-1.08984c-5.256,-2.245 -8.69108,-7.46741 -8.95508,-7.81641c-0.255,-0.34 -2.13477,-2.80661 -2.13477,-5.34961c0,-2.543 1.35094,-3.80131 1.83594,-4.32031c0.476,-0.519 0.8688,-0.64848 1.2168,-0.64648z"></path>
                </g>
              </g>
            </svg> */}
            <svg
              height="70px"
              width="70px"
              version="1.1"
              id="Layer_1"
              xmlns="http://www.w3.org/2000/svg"
              xmlnsXlink="http://www.w3.org/1999/xlink"
              viewBox="0 0 512 512"
              xmlSpace="preserve"
              fill="#000000"
            >
              <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
              <g
                id="SVGRepo_tracerCarrier"
                stroke-linecap="round"
                stroke-linejoin="round"
              ></g>
              <g id="SVGRepo_iconCarrier">
                {" "}
                <circle
                  style={{ fill: "#2bb826" }}
                  cx="256"
                  cy="256"
                  r="256"
                ></circle>{" "}
                <path
                  style={{ fill: "#2bb826" }}
                  d="M360.241,151.826c-14.843-3.712-36.671-16.532-50.8-21.671 c-55.165-17.239-129.293-3.448-149.98,60.337c-1.724,1.724-5.172,1.724-6.896,1.724c-41.374,48.269-13.791,106.882-17.239,160.323 c-1.177,18.839-11.083,35.497-23.831,49.588l107.282,107.17C230.931,511.067,243.355,512,256,512 c126.436,0,231.452-91.665,252.247-212.161L360.241,151.826z"
                ></path>{" "}
                <g>
                  {" "}
                  <path
                    style={{ fill: "#FFFFFF" }}
                    d="M248.837,108.447c-78.029,3.712-139.604,68.696-139.369,146.811 c0.072,23.792,5.816,46.249,15.95,66.095l-15.557,75.514c-0.841,4.086,2.843,7.663,6.901,6.701l73.995-17.53 c19.011,9.471,40.364,14.939,62.962,15.284c79.753,1.219,146.251-62.105,148.74-141.829 C405.121,174.035,334.591,104.362,248.837,108.447L248.837,108.447z M337.13,335.936c-21.669,21.669-50.483,33.604-81.13,33.604 c-17.944,0-35.126-4.027-51.066-11.966l-10.302-5.134l-45.37,10.747l9.549-46.356l-5.075-9.943 c-8.276-16.206-12.472-33.728-12.472-52.084c0-30.648,11.935-59.459,33.604-81.13c21.476-21.478,50.759-33.604,81.134-33.604 c30.644,0,59.458,11.935,81.127,33.604c21.669,21.669,33.604,50.483,33.604,81.127C370.735,285.177,358.607,314.459,337.13,335.936 L337.13,335.936z"
                  ></path>{" "}
                  <path
                    style={{ fill: "#FFFFFF" }}
                    d="M327.115,286.582l-28.384-8.149c-3.729-1.069-7.749-0.01-10.468,2.76l-6.942,7.07 c-2.926,2.984-7.366,3.941-11.24,2.374c-13.427-5.434-41.672-30.548-48.881-43.106c-2.084-3.624-1.739-8.152,0.817-11.462 l6.058-7.839c2.374-3.07,2.874-7.197,1.305-10.747l-11.941-27.008c-2.86-6.468-11.126-8.352-16.527-3.784 c-7.921,6.701-17.32,16.88-18.461,28.16c-2.015,19.887,6.515,44.954,38.762,75.055c37.257,34.778,67.094,39.369,86.523,34.664 c11.019-2.667,19.825-13.365,25.379-22.126C336.906,296.467,333.91,288.535,327.115,286.582L327.115,286.582z"
                  ></path>{" "}
                </g>{" "}
                <g>
                  {" "}
                  <path
                    style={{ fill: "#FFFFFF" }}
                    d="M356.004,147.708l-22.223,22.778c1.131,1.045,2.257,2.096,3.351,3.191 c21.67,21.669,33.604,50.483,33.604,81.127c0,30.375-12.128,59.656-33.604,81.134c-21.669,21.669-50.483,33.604-81.13,33.604 c-17.944,0-35.125-4.027-51.066-11.966l-10.302-5.134l-45.37,10.747l0.938-4.553l-40.174,41.172 c0.886,2.663,3.705,4.475,6.734,3.758l73.995-17.53c19.011,9.471,40.364,14.939,62.962,15.284 c79.753,1.219,146.253-62.105,148.74-141.829C403.834,215.357,385.686,175.435,356.004,147.708z"
                  ></path>{" "}
                  <path
                    style={{ fill: "#FFFFFF" }}
                    d="M327.115,286.582l-28.384-8.149c-3.729-1.069-7.749-0.01-10.468,2.76l-6.942,7.07 c-2.926,2.984-7.366,3.941-11.24,2.374c-7.756-3.139-20.451-12.845-31.185-22.904l-19.732,20.225 c0.677,0.648,1.352,1.295,2.05,1.948c37.257,34.778,67.094,39.369,86.523,34.664c11.019-2.667,19.825-13.365,25.379-22.126 C336.906,296.467,333.91,288.535,327.115,286.582z"
                  ></path>{" "}
                </g>{" "}
              </g>
            </svg>
          </div>
        </a>
      </div>
      <div ref={anchorRef} className="h-1 absolute invisible"></div>
    </>
  );
};

export default SiteHeader;
